import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ConditionGroup, SurveyCondition } from '@models/active-publication.model';
import { TranslateService } from '@ngx-translate/core';
import * as uuid from 'uuid';
import {
  ChangeSurveyCondition
} from '@app/components/publications/create-publication/_store/active-publication.actions';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class PublicationService {
  private BASE_URL = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private translator: TranslateService,
    private store: Store
  ) {

    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Publication SERVICE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');

  }

  getEmailTemplatesList() {
    const url = `${this.BASE_URL}/publications/emailTemplates`;
    return this.http.get<any>(url);
  }

  getPublicationsList(nbMonths: number = 6) {
    const params = new HttpParams().set('nbMonths', nbMonths.toString());
    const url = `${this.BASE_URL}/publications/list`;
    return this.http.get<any>(url, { params });
  }

  AutoArchive(pubUuids: string[] = []) {
    const url = `${this.BASE_URL}/4dm1n/actions`;
    return this.http.post<any>(url, {
      action: 'archivePublications',
      params: {
        pubUuids,
      },
    });

  }

  MultiChangePublishedStatus(pubUuids: string[] = [], published = false) {
    const url = `${this.BASE_URL}/4dm1n/actions`;
    return this.http.post<any>(url, {
      action: 'multiChangePublishedStatus',
      params: {
        pubUuids,
        published,
      },
    });

  }

  clonePublication(pubUuids: string[] = null, username: string) {
    const url = `${this.BASE_URL}/publications/clone`;
    return this.http.post<any>(url, { pubUuids, username });
  }

  deletePublication(id: string) {
    const url = `${this.BASE_URL}/publications/${id}`;
    return this.http.delete<any>(url);
  }

  saveTemplate(template) {
    const url = `${this.BASE_URL}/publications/emailTemplates`;
    return this.http.post<any>(url, { template });
  }

  getSurveysListFromProjectIds(projectsIds: number[]) {
    const url = `${this.BASE_URL}/publications/surveysList`;
    return this.http.post<any>(url, { projectsIds });
  }

  addNewGroup(surveyConditions: SurveyCondition) {
    const newGroupsList = [...surveyConditions.groups];
    newGroupsList.push(this.createNewGroup(surveyConditions));
    this.store.dispatch(new ChangeSurveyCondition(newGroupsList));
  }

  private createNewGroup(surveyConditions: SurveyCondition): ConditionGroup {
    return {
      SQLRules: {
        cssHelp: {
          mapRuleFlag: [],
          mapRuleDepth: [],
        },
        fields: [],
        sqlRule: null,
        whereClauses: [],
      },
      rules: null,
      groupTitle: `${this.translator.instant('Groupe')} - ${surveyConditions.groups.length + 1}`,
      totalRespondent: 0,
      attribuableRespondent: 0,
      totalResult: 0,
      id: uuid.v4(),

      displayMode: 'Horizontal',

      isLoading: false,

      contentToDisplay: {
        surveys: null,
        messages: null,
      }

    };
  }
}
